import { render, staticRenderFns } from "./StudentFileStatistics.vue?vue&type=template&id=9f325482"
import script from "./StudentFileStatistics.vue?vue&type=script&lang=js"
export * from "./StudentFileStatistics.vue?vue&type=script&lang=js"
import style0 from "./StudentFileStatistics.vue?vue&type=style&index=0&id=9f325482&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports